require('./angulartics-ga')
module.exports = 'angulartics.google.analytics'



/*****************
 ** WEBPACK FOOTER
 ** ./~/angulartics-google-analytics/lib/index.js
 ** module id = 544
 ** module chunks = 0
 **/